module.exports = __webpack_public_path__ + "img/facebook.410fbdc0.png";